module.exports = airlineSectors;